// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import router from '@/router'
import store from '@/store/index'
import ajax from '@/libs/ajax'
import flexible from './libs/flexible'
import cookie from 'js-cookie'
import { sync } from 'vuex-router-sync'

import '@/assets/css/reset.css'
import 'katex/dist/katex.min.css'
import VueScroller from 'vue-scroller'
import { wxSetTitle } from '@/libs/title'
import { GLOBAL } from '@/store/mutation-type'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
import Vant from 'vant';
import 'vant/lib/index.css';
 Vue.use(Vant);
Vue.use(ajax)
Vue.use(VueScroller)

/**
 * rem自适应
 */
Vue.use(flexible)

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0)
    if (to.meta.title) {
        document.title = to.meta.title
        wxSetTitle(to.meta.title)
    }
    next()
})

if (process.env.NODE_ENV !== 'production') {
    cookie.set('APP', 'MATH_TEACHER')
    cookie.set('_VERSION', '1.1.1')
    // cookie.set('DEVICE_TYPE', 'IOS')
} else {
    store.dispatch(GLOBAL.ENV)
}
cookie.set('DEVICE_TYPE', '')
sync(store, router)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store
    // template: '<router-view></router-view>'
})



// WEBPACK FOOTER //
// ./src/main.js